import { darken } from 'polished';
import styled from 'styled-components';

export const StyledMessage = styled.div<{ $errorType: 'error' | 'warning' | 'caution' }>`
  padding: ${({ theme }) => theme?.FormErrorMessage?.padding};;
  box-sizing: border-box;
  border: ${({ theme }) => theme?.FormErrorMessage?.border};
  font-weight: ${({ theme }) => theme?.FormErrorMessage?.fontWeight};
  display: flex;
  width: 100%;
  background: ${({ theme }) => theme?.FormErrorMessage?.backgroundColor};
  color: ${({ theme, $errorType }) => {
    if ($errorType === 'caution') return darken(0.25, theme?.FormErrorMessage?.[`${$errorType}Color`]);
    return theme?.FormErrorMessage?.[`${$errorType}Color`];
  }};
`;

export const StyledIcon = styled.svg<{ $errorType: 'error' | 'warning' | 'caution' }>`
  position: relative;
  top: ${(({ theme }) => theme?.FormErrorMessage?.iconTop)}px;
  margin-bottom: -5px;
  width: ${({ theme }) => theme?.FormErrorMessage?.iconSize}px;
  height: ${({ theme }) => theme?.FormErrorMessage?.iconSize}px;
  color: ${({ theme, $errorType }) => theme.colors[$errorType]};
`;

export const StyledIconCol = styled.span`
  padding-right: ${({ theme }) => theme?.FormErrorMessage?.iconPaddingRight}px;
  flex-basis: auto;
`;

export const StyledMessageCol = styled.span`
  font-size: ${({ theme }) => theme.fontSize.base}px;
  line-height: 1.3;
  flex-basis: auto;
  padding-left: 6px;
  text-overflow: ellipsis;

  overflow: hidden;
  min-width: 0;
`;

export const StyledTip = styled.span <{ $errorType: 'error' | 'warning' | 'caution' } >`
  color: ${({ theme, $errorType }) => theme?.FormErrorMessage?.[`${$errorType}Color`]};
  font-weight: ${({ theme }) => theme?.FormErrorMessage?.fontWeight};
  display: flex;
`;
